import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { PageWrapper, DropdownContent, HelmetWrap, ImageStack } from './../../components';
import Waypoint from 'react-waypoint';

class About extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      scrollDown: null,
      imageStackStauts: 'fixed'
    };
  }
  onUpdate = (val) => {
    this.setState({
      scrollDown: val
    });
  };
  parkImageStack() {
    this.setState({
      imageStackStauts: 'parked'
    });
  };
  fixImageStack() {
    this.setState({
      imageStackStauts: 'fixed'
    });
  };
  render() {
    return (
      <PageWrapper pageId={'page-about'}>
        <HelmetWrap pageMeta={this.props.data.page_meta} />
        <section className="main-content">
          <article className={'copy-content formatted-markup'} dangerouslySetInnerHTML={{ __html: this.props.data.content }} />
          <div className={this.state.imageStackStauts + ' gallery-wrap'}>
            <ImageStack imgs={this.props.data.gallery} />
          </div>
        </section>
        <Waypoint onEnter={this.parkImageStack.bind(this, true)} onLeave={this.fixImageStack.bind(this, true)} />
        <section className='dropdown-wrapper'>
          {this.props.data.sections.map((item, i) =>
            <DropdownContent key={'gen-section-' + i} header={item.section_title} body={'<div class="formatted-markup">' + item.section_content + '</div>'} />
          )}
        </section>
      </PageWrapper>
    );
  };

};

export default connect(
  state => ({
    scrollDirection: state.scroll_direction
  })
)(About);



// WEBPACK FOOTER //
// ./src/pages/about/About.js